import { type SxProps, type Theme } from '@mui/system';

export const contentSx: SxProps<Theme> = {
  padding: {
    sm: '30px 30px 0px',
    md: '35px 60px 0px',
    lg: '35px 150px 0px',
  },
  width: '100%',
  minHeight: '100%',
};

export const titleSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '27px',
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
  '& .title': {
    fontWeight: 'bold',
    fontSize: '28px',
    lineHeight: '34px',
    color: '#006EC2',
  },
  '& .subTitle': {
    display: 'inline-block',
    fontSize: '18px',
    lineHeight: '25px',
    color: '#FFFFFF',
    background: '#006EC2',
    padding: '0px 24px',
    marginLeft: '19px',
    borderRadius: '2px',
  },
  '& .second-row': {
    textAlign: {
      xs: 'end',
      md: 'unset',
    },
    marginTop: {
      xs: '20px',
      md: '0px',
    },
    '& .MuiButton-root': {
      fontSize: '18px',
      lineHeight: '22px',
    },
  },
};

export const userListSx: SxProps<Theme> = {
  '& .iconEdit': {
    fontSize: '14px',
    color: '#006EC2',
  },
  '& th:first-of-type': {
    borderTopLeftRadius: '5px',
  },
  '& th:last-of-type': {
    borderTopRightRadius: '5px',
  },
};

export const userDialogSx: SxProps<Theme> = {
  '& .error-msg': {
    color: 'red',
    padding: '0 0 0 155px',
    fontSize: '16px',
    height: '26px',
  },
  '& .bi-x': {
    position: 'absolute',
    top: '42px',
    right: '40px',
    cursor: 'pointer',
  },
  '& .MuiPaper-root': {
    margin: {
      xs: '6px',
      md: '32px',
    },
    minWidth: {
      xs: '360px',
      lg: '800px',
    },
  },
  '& .MuiDialogContent-root': {
    padding: '12px',
  },
  '& .MuiDialogTitle-root': {
    color: '#006EC2',
    fontSize: '28px',
    fontWeight: 'bold',
    borderBottom: 'solid 2px #ECECEC',
    margin: '0px 30px 30px',
    padding: '34px 0px 15px',
  },
  '& label': {
    color: '#006EC2',
    fontSize: '18px',
    fontWeight: 'bold',
    marginRight: {
      xs: '12px',
      md: '24px',
    },
    minWidth: '125px',
    textAlign: 'right',
  },
  '& .MuiOutlinedInput-input': {
    padding: '7px 16px',
    color: '#000000',
    fontSize: '18px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#006EC2',
  },
  '& .checkbox-label': {
    fontSize: '18px',
    minWidth: {
      xs: 'auto',
      md: '140px',
    },
    display: 'inline-block',
    textTransform: 'capitalize',
  },
  '& .MuiCheckbox-root': {
    padding: '0px 9px',
  },
  '& .confirm-row': {
    fontSize: '18px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    '& > span:first-of-type': {
      color: '#006EC2',
      width: '50%',
      textAlign: 'right',
      display: 'inline-block',
      marginRight: '20px',
      fontWeight: 'bold',
    },
    '& .password-box': {
      border: 'solid 1px #006EC2',
      padding: '7px 15px',
      borderRadius: '2px',
      height: '36px',
      marginRight: '-2px',
    },
  },
  '& .MuiDialogActions-root': {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '50px',
    '& .MuiButton-root': {
      width: '132px',
      textTransform: 'none',
      fontSize: '18px',
      background: '#006EC2',
    },
    '& .Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      background: 'rgba(0, 0, 0, 0.12)',
    },
    '& .error-msg': {
      color: 'red',
      marginTop: '12px',
    },
  },
};
